import { render, staticRenderFns } from "./modal-production-compensation.vue?vue&type=template&id=1d796898&scoped=true&"
import script from "./modal-production-compensation.vue?vue&type=script&lang=js&"
export * from "./modal-production-compensation.vue?vue&type=script&lang=js&"
import style0 from "./modal-production-compensation.vue?vue&type=style&index=0&id=1d796898&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d796898",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d796898')) {
      api.createRecord('1d796898', component.options)
    } else {
      api.reload('1d796898', component.options)
    }
    module.hot.accept("./modal-production-compensation.vue?vue&type=template&id=1d796898&scoped=true&", function () {
      api.rerender('1d796898', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calculations/create/additions/modal-production-compensation.vue"
export default component.exports